import React, { useState } from 'react';
import { JoinOrganizationView, JoinOrganizationViewProps } from './JoinOrganization.view';
import { useAuth } from '../../../hooks/useAuth';
import { triggerErrorToast } from '../../../helpers/triggerErrorToast';
import { useReactiveVar } from '@apollo/client';
import { IInvitation } from '../../../models/auth';
import { invitationDetailsVar } from '../../../providers/AppProvider';

export type JoinOrganizationControllerProps = Omit<
  JoinOrganizationViewProps,
  'joinWithDifferentEmail' | 'setLoading' | 'loading'
> & {
  // extend your JoinOrganizationViewProps
};

export const JoinOrganizationController = (props: JoinOrganizationControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const { logout } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const invitation: IInvitation | null = useReactiveVar(invitationDetailsVar);

  const joinWithDifferentEmail = async (): Promise<void> => {
    setLoading(true);
    try {
      if (invitation) {
        sessionStorage.setItem('invitation', JSON.stringify(invitation));
      }
      await logout('/signup?ab_signup_app=1');
    } catch (e) {
      // we need to catch promise due to runtime errors
      triggerErrorToast('Logout Error')(e);
    }
  };

  const viewProps: JoinOrganizationViewProps = { ...props, joinWithDifferentEmail, loading, setLoading };
  return <JoinOrganizationView {...viewProps} />;
};
